import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Navbar   from './components/Navbar';
import Footer   from './components/Footer';

import Home          from './pages/Home';
import About         from './pages/About';
import Software      from './pages/Software';
import Training      from './pages/Training';
import Contact       from './pages/Contact';
import NotFound      from './pages/NotFound';

export default function App() {
  const { pathname, hash } = useLocation();

  // Scroll to the hash target if present, otherwise scroll to top
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'instant', block: 'start' });
        el.classList.remove('anchor-highlight');
        // eslint-disable-next-line no-unused-expressions
        el.offsetWidth; // restart animation if the same target is hit twice in a row
        el.classList.add('anchor-highlight');
        const timer = setTimeout(() => el.classList.remove('anchor-highlight'), 1600);
        return () => clearTimeout(timer);
      }
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/"                element={<Home />} />
          <Route path="/about-us"        element={<About />} />
          <Route path="/software"        element={<Software />} />
          <Route path="/training"        element={<Training />} />
          <Route path="/contact-us"      element={<Contact />} />
          <Route path="*"                element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
